import Vue from "vue";
import App from "./App.vue";
import vuescroll from "vuescroll";
import router from "./router";

import "./assets/styles/main.css";
import "vuescroll/dist/vuescroll.css";

Vue.config.productionTip = false;

Vue.use(vuescroll, {
  ops: {
    mode: "native",
    sizeStrategy: "percent",
    detectResize: true,
    bar: {
      background: getComputedStyle(document.documentElement).getPropertyValue(
        "--color-tertiary"
      ),
      showDelay: 500,
      onlyShowBarOnScroll: true,
      keepShow: false,
      opacity: 1,
      hoverStyle: false,
      specifyBorderRadius: false,
      minSize: 0,
      size: "6px",
      disable: false,
    },
  },
  name: "scroll",
});

new Vue({
  router,
  render: (h) => h(App),
  watch: {
    $route(to) {
      document.title = to.meta.title || "Inicio";
    },
    immediate: true,
  },
}).$mount("#app");

window.events = new Vue();

window.cerrarMenu = window.events.$emit("cerrarMenu");
